var _rect, _path, _path2, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.00012207,
    y: 0.964233,
    width: 56,
    height: 56,
    rx: 8,
    fill: "#E7EEF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1458 46.9082C19.8676 46.9082 13.1549 40.1935 13.1549 31.9082C13.1549 23.6229 19.8676 16.9082 28.1458 16.9082C36.4241 16.9082 43.1368 23.6229 43.1368 31.9082C43.1368 40.1935 36.4241 46.9082 28.1458 46.9082Z",
    stroke: "#00518B",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8639 43.6791C39.7196 43.6791 37.8639 41.8594 37.8639 39.4673C37.8639 37.0752 39.7196 35.2555 41.8639 35.2555C44.0082 35.2555 45.8639 37.0752 45.8639 39.4673C45.8639 41.8594 44.0082 43.6791 41.8639 43.6791Z",
    fill: "#F0F3F7",
    stroke: "#EB7F2C",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.2276,
    cy: 15.0201,
    r: 4,
    transform: "rotate(90 28.2276 15.0201)",
    fill: "#F0F3F7",
    stroke: "#EB7F2C",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.1364,
    cy: 39.2555,
    r: 4,
    transform: "rotate(90 14.1364 39.2555)",
    fill: "#F0F3F7",
    stroke: "#EB7F2C",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.9db92c6ba8b51f3e11a07b3711f9193a.svg";
export { ForwardRef as ReactComponent };